import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { BrandDetails, BrandDetailsVariables } from "./types/BrandDetails";
const getBrandDetails = gql`
  query BrandDetails($id: ID!) {
    brandPrivate(id: $id) {
      id
      name
      legalName
      code
      accountManager {
        id
        email
        firstName
        lastName
      }
      completeAddress
      vendorId
      mobileNo
      status
      tinNo
      signatoryName
      signatoryEmail
      signatoryDesignation
      signatoryMobileNo
      bankName
      bankAccountName
      bankAccountNo
      financeName
      financeEmail
      financeMobileNo
      storeType
      sellerId
    }
  }
`;

export const useBrandQuery = makeQuery<BrandDetails, BrandDetailsVariables>(
  getBrandDetails
);
